/**
 * The rule the API applies to a new password (reset and change): 8 to 128
 * characters with at least one uppercase letter, one lowercase letter and one
 * number. Check it before sending so the user gets the message in their own
 * language instead of the API's English one.
 */
export const PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,128}$/;

/**
 * @param {string} password
 * @returns {boolean} true when the API will accept it as a new password
 */
export function isValidNewPassword(password) {
  return PASSWORD_RULE.test(String(password || ''));
}
